webpackJsonp([2],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2mV7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__("WSTi");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__app__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consents__ = __webpack_require__("Fty7");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__consents__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__drivers__ = __webpack_require__("S3jc");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__drivers__["a"]; });




/***/ }),

/***/ "4X0a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("O67t");


var baseUrl = '/drivers';
var part = function part(_part) {
  return '' + (_part ? '/' + _part : '');
};
var url = function url() {
  for (var _len = arguments.length, parts = Array(_len), _key = 0; _key < _len; _key++) {
    parts[_key] = arguments[_key];
  }

  return baseUrl + parts.map(part).join('');
};

// https://fonixtelematics.atlassian.net/wiki/spaces/DLC/pages/33751041/API

var dataOrDefault = function dataOrDefault(request, defData) {
  return request.data || defData;
};
// const toArray = (request) => dataOrDefault(request, [])

/* harmony default export */ __webpack_exports__["a"] = ({
  self: function self() {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get(url('self')).then(dataOrDefault);
  },
  updateSelf: function updateSelf(driver) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].put(url('self'), driver);
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get(url(id)).then(dataOrDefault);
  }
});

/***/ }),

/***/ "4YjO":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("YljR");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("fe2885e6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-427a9fc7\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-427a9fc7\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "CWKO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "page-wrapper"
  }, [_c('header', [_c('p', [_vm._v("Driver Licence Check")]), _vm._v(" "), (_vm.isLoggedIn && !_vm.isProfileRoute) ? _c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_vm._v("My details")]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn && _vm.isProfileRoute) ? _c('router-link', {
    attrs: {
      "to": "/consents"
    }
  }, [_vm._v("My approvals")]) : _vm._e()], 1), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('footer', [_vm._v("\n    © " + _vm._s(new Date().getFullYear()) + " Fonix Telematics\n    "), (_vm.isLoggedIn) ? _c('router-link', {
    attrs: {
      "to": "/logout"
    }
  }, [_vm._v("Logout")]) : _vm._e(), _vm._v(" "), _c('small', {
    staticClass: "version"
  }, [_vm._v(" \\ v" + _vm._s(_vm.version))])], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-427a9fc7", esExports)
  }
}

/***/ }),

/***/ "CdoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("O67t");


var baseUrl = '/consents';
var part = function part(_part) {
  return '' + (_part ? '/' + _part : '');
};
var url = function url() {
  for (var _len = arguments.length, parts = Array(_len), _key = 0; _key < _len; _key++) {
    parts[_key] = arguments[_key];
  }

  return baseUrl + parts.map(part).join('');
};

// https://fonixtelematics.atlassian.net/wiki/spaces/DLC/pages/33751041/API

var dataOrDefault = function dataOrDefault(request, defData) {
  return request.data || defData;
};
var toArray = function toArray(request) {
  return dataOrDefault(request, []);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get(url()).then(toArray);
  },
  getSingle: function getSingle(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get(url(id)).then(dataOrDefault);
  },
  accept: function accept(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].post(url(id, 'accept'));
  },
  grant: function grant(id, pin) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].post(url(id, 'grant'), { pin: pin });
  },
  revoke: function revoke(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete(url(id));
  }
});

/***/ }),

/***/ "CyCq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  baseURL:  false ? 'https://dlc.develop.fonixapis.com' : 'https://dlc.fonixapis.com',
  debug: "production" !== 'production'
});

/***/ }),

/***/ "Fty7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONSENT_STATES; });
/* unused harmony export MUTATION_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return consentsModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_consents__ = __webpack_require__("CdoT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_app__ = __webpack_require__("WSTi");




var _actions;





var CONSENT_STATES = {
  PENDING: 'pending',
  REVOKED: 'revoked',
  GRANTED: 'granted'
};

var MUTATION_TYPES = {
  SET_CONSENTS: 'SET_CONSENTS'
};

var ACTION_TYPES = {
  GET_ALL_CONSENTS: 'GET_ALL_CONSENTS',
  GET_CONSENT: 'GET_CONSENT',
  ACCEPT_CONSENT: 'ACCEPT_CONSENT',
  GRANT_CONSENT: 'CONFIRM_CONSENT',
  REVOKE_CONSENT: 'REVOKE_CONSENT'
};

var state = {
  all: []
};

var getters = {
  allConsents: function allConsents(state) {
    return state.all;
  }

  // TODO catch401 should be a generic?
};var logoutOn401 = function logoutOn401(response, dispatch, defaultData) {
  if (dispatch && response && response.request && (response.request.status === 401 || response.request.status === 0)) {
    dispatch(__WEBPACK_IMPORTED_MODULE_4__store_modules_app__["b" /* ACTION_TYPES */].LOGOUT);
    window.location.reload();
  }
  return defaultData;
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, ACTION_TYPES.GET_ALL_CONSENTS, function (_ref) {
  var _this = this;

  var commit = _ref.commit,
      dispatch = _ref.dispatch;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
    var items;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_3__services_api_consents__["a" /* default */].getAll().catch(function (res) {
              logoutOn401(res, dispatch, []);
            });

          case 2:
            items = _context.sent;


            commit(MUTATION_TYPES.SET_CONSENTS, { consents: items });
            return _context.abrupt('return', items);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, ACTION_TYPES.GET_CONSENT, function (_ref2, id) {
  var _this2 = this;

  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __WEBPACK_IMPORTED_MODULE_3__services_api_consents__["a" /* default */].getSingle(id).catch(function (res) {
              return logoutOn401(res);
            });

          case 2:
            return _context2.abrupt('return', _context2.sent);

          case 3:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this2);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, ACTION_TYPES.ACCEPT_CONSENT, function (_ref3, _ref4) {
  var _this3 = this;

  var commit = _ref3.commit,
      dispatch = _ref3.dispatch;
  var id = _ref4.id;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return __WEBPACK_IMPORTED_MODULE_3__services_api_consents__["a" /* default */].accept(id).then(function (_) {
              return true;
            }).catch(function (res) {
              return logoutOn401(res, dispatch, false);
            });

          case 2:
            return _context3.abrupt('return', _context3.sent);

          case 3:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this3);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, ACTION_TYPES.GRANT_CONSENT, function (_ref5, _ref6) {
  var _this4 = this;

  var commit = _ref5.commit,
      dispatch = _ref5.dispatch;
  var id = _ref6.id,
      pin = _ref6.pin;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return __WEBPACK_IMPORTED_MODULE_3__services_api_consents__["a" /* default */].grant(id, pin).then(function (res) {
              return res.data;
            }).catch(function (_) {
              return null;
            });

          case 2:
            return _context4.abrupt('return', _context4.sent);

          case 3:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this4);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, ACTION_TYPES.REVOKE_CONSENT, function (_ref7, _ref8) {
  var _this5 = this;

  var commit = _ref7.commit,
      dispatch = _ref7.dispatch;
  var id = _ref8.id;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return __WEBPACK_IMPORTED_MODULE_3__services_api_consents__["a" /* default */].revoke(id).then(function (_) {
              return true;
            }).catch(function (_) {
              return false;
            });

          case 2:
            return _context5.abrupt('return', _context5.sent);

          case 3:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this5);
  }))();
}), _actions);

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, MUTATION_TYPES.SET_CONSENTS, function (state, _ref9) {
  var consents = _ref9.consents;

  state.all = consents;
});

var consentsModule = {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules__ = __webpack_require__("2mV7");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  strict: debug,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_2__modules__["a" /* appModule */],
    consents: __WEBPACK_IMPORTED_MODULE_2__modules__["b" /* consentsModule */],
    drivers: __WEBPACK_IMPORTED_MODULE_2__modules__["c" /* driversModule */]
  }
}));

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427a9fc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("CWKO");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("4YjO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427a9fc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-427a9fc7", Component.options)
  } else {
    hotAPI.reload("data-v-427a9fc7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_polyfills__ = __webpack_require__("POV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_polyfills___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_polyfills__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
// polyfills for ie10



// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

// https://github.com/vuejs-templates/webpack/issues/215#issuecomment-287652462
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  render: function render(createEle) {
    return createEle(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */]);
  }
}).$mount('#app');

/***/ }),

/***/ "O67t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_config__ = __webpack_require__("CyCq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_storage__ = __webpack_require__("uTIJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);







var headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'X-Requested-With': 'Fetch',
  'accept-enconding': 'gzip'
};

var apiError = function apiError(request) {
  // LOG ERRORS
  // use interceptor instead ?
  window.lastError = request;
  console.warn('apiError', request);
  var responsedata = request.response && request.response.data || undefined;
  request.responseMessage = responsedata && responsedata.message || request.message;
  // propagate rejection
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(request);
};

var API = function () {
  function API(_ref) {
    var baseURL = _ref.baseURL;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, API);

    this.axios = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.create({
      baseURL: baseURL,
      headers: headers
    });

    this.setToken(__WEBPACK_IMPORTED_MODULE_4__services_storage__["a" /* default */].get('token'));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(API, [{
    key: 'setToken',
    value: function setToken(token) {
      this.axios.defaults.headers['authorization'] = 'Bearer ' + token;
    }
  }, {
    key: 'get',
    value: function get(url, params) {
      return this.request('get', url, null, { params: params });
    }
  }, {
    key: 'put',
    value: function put(url, data, config) {
      return this.request('put', url, data, config);
    }
  }, {
    key: 'post',
    value: function post(url, data, config) {
      return this.request('post', url, data, config);
    }
  }, {
    key: 'delete',
    value: function _delete(url, config) {
      return this.request('delete', url, null, config);
    }
  }, {
    key: 'request',
    value: function request(method, url, data, config) {
      console.log('request', method, url);
      return this.axios[method](url, data, config).catch(apiError);
    }
  }]);

  return API;
}();

/* harmony default export */ __webpack_exports__["a"] = (new API(__WEBPACK_IMPORTED_MODULE_3__services_config__["a" /* default */]));

/***/ }),

/***/ "POV0":
/***/ (function(module, exports) {

// https://tc39.github.io/ecma262/#sec-array.prototype.find
/* eslint-disable */

if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function value(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    }
  });
}

/***/ }),

/***/ "S3jc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MUTATION_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return driversModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_drivers__ = __webpack_require__("4X0a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_app__ = __webpack_require__("WSTi");




var _actions;




var MUTATION_TYPES = {
  SET_SELF: 'SET_SELF'
};

var ACTION_TYPES = {
  GET_SELF: 'GET_SELF',
  UPDATE_SELF: 'UPDATE_SELF'
};

var state = {
  self: {
    name: 'John'
  }
};

var getters = {
  self: function self(_self) {
    return state.self;
  }

  // TODO catch401 should be a generic?
};var logoutOn401 = function logoutOn401(response, dispatch, defaultData) {
  if (dispatch && response && response.request && (response.request.status === 401 || response.request.status === 0)) {
    dispatch(__WEBPACK_IMPORTED_MODULE_4__store_modules_app__["b" /* ACTION_TYPES */].LOGOUT);
    window.location.reload();
  }
  return defaultData;
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, ACTION_TYPES.GET_SELF, function (_ref) {
  var _this = this;

  var commit = _ref.commit,
      dispatch = _ref.dispatch;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
    var driver;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_3__services_api_drivers__["a" /* default */].self().catch(function (res) {
              return logoutOn401(res, dispatch, null);
            });

          case 2:
            driver = _context.sent;

            commit(MUTATION_TYPES.SET_SELF, driver);
            return _context.abrupt('return', driver);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, ACTION_TYPES.UPDATE_SELF, function (_ref2, driver) {
  var _this2 = this;

  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var updated;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __WEBPACK_IMPORTED_MODULE_3__services_api_drivers__["a" /* default */].updateSelf(driver);

          case 2:
            updated = _context2.sent;


            console.log('updated', updated);
            commit(MUTATION_TYPES.SET_SELF, updated);

            return _context2.abrupt('return', updated);

          case 6:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this2);
  }))();
}), _actions);

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, MUTATION_TYPES.SET_SELF, function (state, driver) {
  state.self = driver;
});

var driversModule = {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};

/***/ }),

/***/ "WSTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MUTATION_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_storage__ = __webpack_require__("uTIJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api_auth__ = __webpack_require__("xzo8");





var _actions;




// import config from '@/services/config'

var MUTATION_TYPES = {
  'SET_LOGIN': 'SET_LOGIN'
};

var ACTION_TYPES = {
  REQUEST: 'REQUEST',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  MAGIC_LOGIN: 'MAGIC_LOGIN'
};

var state = {
  token: __WEBPACK_IMPORTED_MODULE_4__services_storage__["a" /* default */].get('token')
};

var getters = {
  isLoggedIn: function isLoggedIn(state) {
    return !!state.token;
  },
  authToken: function authToken(state) {
    return state.token;
  }
};

var mutations = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, MUTATION_TYPES.SET_LOGIN, function (state, token) {
  state.token = token;

  if (token === null || token === undefined) {
    __WEBPACK_IMPORTED_MODULE_4__services_storage__["a" /* default */].remove('token');
    return;
  }

  //
  __WEBPACK_IMPORTED_MODULE_4__services_storage__["a" /* default */].set('token', token);
  __WEBPACK_IMPORTED_MODULE_5__services_api_auth__["a" /* default */].setToken(token);
});

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, ACTION_TYPES.LOGIN, function (_ref, _ref2) {
  var _this = this;

  var commit = _ref.commit,
      state = _ref.state;
  var username = _ref2.username,
      password = _ref2.password;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
    var response, token;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_5__services_api_auth__["a" /* default */].login(username, password).catch(function (e) {
              return false;
            });

          case 2:
            response = _context.sent;


            // find smarted way to check this, maybe inside auth.login
            token = null;

            if (response && response.status >= 200 && response.status <= 300) {
              token = response.data.token;
            }

            // commit to store
            commit(MUTATION_TYPES.SET_LOGIN, token);

            return _context.abrupt('return', !!token);

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }))();
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, ACTION_TYPES.MAGIC_LOGIN, function (_ref4, _ref3) {
  var _this2 = this;

  var commit = _ref4.commit,
      state = _ref4.state;

  var username = _ref3.username,
      password = _ref3.password,
      driver = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ['username', 'password']);

  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __WEBPACK_IMPORTED_MODULE_5__services_api_auth__["a" /* default */].login(username, password, driver).catch(function (e) {
              return e.response;
            });

          case 2:
            response = _context2.sent;


            if (response.status >= 200 && response.status <= 300) {
              commit(MUTATION_TYPES.SET_LOGIN, response.data.token);
            }

            return _context2.abrupt('return', response);

          case 5:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this2);
  }))();
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, ACTION_TYPES.LOGOUT, function (_ref5) {
  var _this3 = this;

  var commit = _ref5.commit;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            commit(MUTATION_TYPES.SET_LOGIN);

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this3);
  }))();
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, ACTION_TYPES.REQUEST, function (_ref6, _ref7) {
  var _this4 = this;

  var commit = _ref6.commit,
      state = _ref6.state;
  var username = _ref7.username,
      returnUrl = _ref7.returnUrl;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return __WEBPACK_IMPORTED_MODULE_5__services_api_auth__["a" /* default */].request(username, returnUrl).then(function (res) {
              return true;
            }).catch(function (e) {
              return false;
            });

          case 2:
            _context4.next = 4;
            return _context4.sent;

          case 4:
            return _context4.abrupt('return', _context4.sent);

          case 5:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this4);
  }))();
}), _actions);

var appModule = {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

// const importPageChunk = (path) => import(/* webpackChunkName: "pages" */ path)
var LoginPage = function LoginPage() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "idAo"));
};
var ConsentsPage = function ConsentsPage() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "szM8"));
};
var ConsentDetailsPage = function ConsentDetailsPage() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "v1GJ"));
};
var NotFoundPage = function NotFoundPage() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "x7AD"));
};
var MagicLinkPage = function MagicLinkPage() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "h3WT"));
};
var LogoutPage = function LogoutPage() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "SeGl"));
};
var DriverProfilePage = function DriverProfilePage() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "oTof"));
};

var routeAuthGuard = function routeAuthGuard(redirectRoute) {
  var loggedRoute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var withReturnUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (to, from, next) {
    var _redirectRoute = withReturnUrl ? redirectRoute + '?return=' + to.fullPath : redirectRoute;
    var nextRoute = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.isLoggedIn ? loggedRoute : _redirectRoute;

    console.log('routeAuthGuard sending to ', nextRoute);
    next(nextRoute);
  };
};

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({

  routes: [{
    path: '/login',
    name: 'login',
    component: LoginPage,
    beforeEnter: routeAuthGuard(undefined, '/')
  }, {
    path: '/magic',
    name: 'magic-link',
    component: MagicLinkPage
  }, {
    path: '/logout',
    name: 'logout',
    component: LogoutPage,
    beforeEnter: routeAuthGuard('/login')
  }, {
    path: '/',
    alias: '/consents',
    name: 'consents',
    component: ConsentsPage,
    beforeEnter: routeAuthGuard('/login')
  }, {
    path: '/consents/:id',
    name: 'consent-details',
    component: ConsentDetailsPage,
    props: true,
    beforeEnter: routeAuthGuard('/login', undefined, true)
  }, {
    path: '/profile',
    name: 'driver-profile',
    component: DriverProfilePage,
    beforeEnter: routeAuthGuard('/login')
  }, {
    path: '*',
    component: NotFoundPage
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YljR":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.text-left {\n  text-align: left;\n}\n.text-right {\n  text-align: right;\n}\n.text-center {\n  text-align: center;\n}\n.no-opacity {\n  opacity: 0;\n}\n.no-padding {\n  padding: 0;\n}\n.no-margin {\n  margin: 0 !important;\n}\n.no-radius {\n  border-radius: 0;\n}\n.no-border {\n  border: none;\n}\n.anim-opacity {\n  -webkit-transition: opacity 0.3s ease;\n  transition: opacity 0.3s ease;\n}\n.invisble {\n  opacity: 0;\n}\n.visible {\n  opacity: 1;\n}\n.inline-block {\n  display: inline-block;\n}\n.capitalize {\n  text-transform: capitalize;\n}\n.uppercase {\n  text-transform: uppercase;\n}\n.absolute-center {\n  width: 50%;\n  margin: auto;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n.va-middle {\n  vertical-align: middle;\n}\n.va-bottom {\n  vertical-align: bottom;\n}\n.clearfix:after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n.text-flow {\n  overflow: hidden;\n  word-break: break-all;\n}\n.text-ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.absolute-bottom {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  left: 0;\n}\n.hover-state:hover {\n  opacity: 0.5;\n  cursor: pointer;\n}\n.flex, .flex-center {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.flex-row {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n.flex-col {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.flex-center {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.flex-align-center {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.flex-justify-center {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.flex-justify-end {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.flex-center-self {\n  -ms-flex-item-align: center;\n      align-self: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.padded {\n  padding: 0 10px;\n}\n.padded-right {\n  padding-right: 10px;\n}\n.padded-left {\n  padding-left: 10px;\n}\n.padded-full {\n  padding: 10px;\n}\n.spaced {\n  margin: 0 10px;\n}\n.flex-1 {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.flex-2 {\n  -webkit-box-flex: 2;\n      -ms-flex: 2;\n          flex: 2;\n}\n.flex-3 {\n  -webkit-box-flex: 3;\n      -ms-flex: 3;\n          flex: 3;\n}\n.flex-4 {\n  -webkit-box-flex: 4;\n      -ms-flex: 4;\n          flex: 4;\n}\n.flex-5 {\n  -webkit-box-flex: 5;\n      -ms-flex: 5;\n          flex: 5;\n}\n.flex-6 {\n  -webkit-box-flex: 6;\n      -ms-flex: 6;\n          flex: 6;\n}\n.flex-7 {\n  -webkit-box-flex: 7;\n      -ms-flex: 7;\n          flex: 7;\n}\n.flex-8 {\n  -webkit-box-flex: 8;\n      -ms-flex: 8;\n          flex: 8;\n}\n.flex-9 {\n  -webkit-box-flex: 9;\n      -ms-flex: 9;\n          flex: 9;\n}\n.flex-10 {\n  -webkit-box-flex: 10;\n      -ms-flex: 10;\n          flex: 10;\n}\n.flex-11 {\n  -webkit-box-flex: 11;\n      -ms-flex: 11;\n          flex: 11;\n}\n.flex-12 {\n  -webkit-box-flex: 12;\n      -ms-flex: 12;\n          flex: 12;\n}\n.fade-enter-active,\n.fade-leave-active {\n  -webkit-transition: opacity .35s;\n  transition: opacity .35s;\n}\n.fade-enter,\n.fade-leave-to {\n  opacity: 0;\n}\nhtml, * {\n  font-family: \"Exo 2\", -apple-system, BlinkMacSystemFont,\"Segoe UI\",\"Roboto\", \"Droid Sans\",\"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\nbody {\n  background: #f2f2f2;\n}\n*:focus,\n*:active {\n  outline: 0;\n}\nform {\n  border: 0;\n  background: inherit;\n}\nform .responsive-label {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\nform .row.responsive-label > input {\n  margin: .3em 0;\n}\ninput:not([type=\"button\"]):not([type=\"submit\"]):not([type=\"reset\"])[readonly], textarea[readonly], select[readonly] {\n  background: #f2f2f2;\n}\nbutton.primary,\n[type=button].primary,\n[type=submit].primary {\n  background: #4976bc;\n}\nbutton.secondary,\n[type=button].secondary,\n[type=submit].secondary {\n  background: #617D8B;\n}\nbutton.secondary:hover, button.secondary:active, button.secondary:focus,\n  [type=button].secondary:hover,\n  [type=button].secondary:active,\n  [type=button].secondary:focus,\n  [type=submit].secondary:hover,\n  [type=submit].secondary:active,\n  [type=submit].secondary:focus {\n    background: #485d67;\n}\nbutton .spinner-donut,\n[type=button] .spinner-donut {\n  height: 12px;\n  width: 12px;\n  vertical-align: sub;\n}\n.toast {\n  width: 50%;\n  min-width: 270px;\n  max-width: 400px;\n  padding: 0.75rem 1.3rem;\n  background: #E43939;\n}\n.toast.success {\n  background: #05b705;\n}\n.toast-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.toast-message {\n  display: inline-block;\n  max-width: 80%;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.toast-close {\n  position: absolute;\n  right: 1.5rem;\n}\n.toast-close:hover {\n    background: none;\n    opacity: 0.5;\n}\n.print-only {\n  display: none;\n}\nhtml,\nbody,\n#app {\n  height: 100%;\n  min-width: 400px;\n}\n#app {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: #f1f1f1;\n  overflow: auto;\n}\n#app .page-wrapper {\n    min-height: calc(100% - (20px + 1rem));\n}\n#app header,\n  #app footer {\n    background: #465A64;\n}\n#app header {\n    font-weight: bold;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n#app header a {\n    color: #d6d6d6;\n    text-decoration: none;\n    font-size: 0.75rem;\n    text-transform: uppercase;\n}\n#app header a:hover {\n      text-decoration: underline;\n}\n#app header a.router-link-active {\n      display: none;\n}\n#app footer {\n    margin: 0;\n    height: 20px;\n    padding: 0.5rem;\n}\n#app footer a {\n    color: #c0c0c0;\n    float: right;\n    font-size: 0.9rem;\n}\n#app .version {\n    font-size: 0.6rem;\n}\n", ""]);

// exports


/***/ }),

/***/ "uTIJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

// todo: handle missing window.localStorage
var _storage = window.localStorage;

// notes:
// localstorage stores null as "null"(string)
/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(key) {
    var v = _storage.getItem(key);
    try {
      return JSON.parse(v) || v;
    } catch (e) {
      return v;
    }
  },
  set: function set(key, value) {
    _storage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
  },
  has: function has(key) {
    var v = this.get(key);
    return v !== null && v !== 'null' && v !== undefined;
  },
  remove: function remove(key) {
    _storage.removeItem(key);
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* global __VERSION__ */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['isLoggedIn']), {
    isProfileRoute: function isProfileRoute() {
      return this.$route.name === 'driver-profile';
    }
  }),
  data: function data() {
    return {
      version: "0.2.1"
    };
  }
});

/***/ }),

/***/ "xzo8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("O67t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_config__ = __webpack_require__("CyCq");




/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(username, password, extra) {
    console.log('logn', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ username: username, authKey: password }, extra));
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post('auth/login', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ username: username, authKey: password }, extra));
  },
  request: function request(username, returnUrl) {
    var url = 'auth/request' + (returnUrl ? '?returnUrl=' + returnUrl : '');

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post(url, { username: username, isDebug: __WEBPACK_IMPORTED_MODULE_2__services_config__["a" /* default */].debug }).then(function (res) {
      if (__WEBPACK_IMPORTED_MODULE_2__services_config__["a" /* default */].debug) {
        console.log(res.data.authKey);
      }
      return res;
    });
  },
  setToken: function setToken(token) {
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].setToken(token);
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5f94660a889be6af5210.js